import { render, staticRenderFns } from "./RequisitionTabs.vue?vue&type=template&id=2d9bfcc0&scoped=true"
import script from "./RequisitionTabs.vue?vue&type=script&lang=js"
export * from "./RequisitionTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9bfcc0",
  null
  
)

export default component.exports